import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import cookies from "js-cookie";

import { cartApi } from "../../../store/Actions/cartActions";
import {
  buildCatalogue,
  formatPrice,
  isKiloOverCategory,
  localeKey,
  productName,
} from "../../../utils/catalogue";
import HomeHero from "./HomeHero";
import "./catalogue.css";

/**
 * Page d'accueil — design « Catalogue C · rail catégories ».
 *
 * Rail des sur-catégories à gauche, catalogue au centre, panier à droite.
 * Les icônes des trois niveaux viennent de l'API (voir utils/catalogue) :
 * rien n'est dessiné en dur ici, hormis les pictos d'interface.
 */

const LANGUAGES = [
  { code: "fn", label: "FR" },
  { code: "du", label: "NL" },
  { code: "en", label: "EN" },
];

const Sprite = () => (
  <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
    <defs>
      <symbol id="cat-bag" viewBox="0 0 512 512">
        <path
          d="M80,176a16,16,0,0,0-16,16V408c0,30.24,25.76,56,56,56H392c30.24,0,56-24.51,56-54.75V192a16,16,0,0,0-16-16Z"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
        <path
          d="M160,176V144a96,96,0,0,1,96-96h0a96,96,0,0,1,96,96v32"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32px",
          }}
        />
      </symbol>
      <symbol id="cat-check" viewBox="0 0 512 512">
        <polyline
          points="416 128 192 384 96 288"
          style={{
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "44px",
          }}
        />
      </symbol>
      <symbol id="cat-apple" viewBox="0 0 512 512">
        <path
          d="M349.13,136.86c-40.32,0-57.36,19.24-85.44,19.24C234.9,156.1,212.94,137,178,137c-34.2,0-70.67,20.88-93.83,56.45-32.52,50.16-27,144.63,25.67,225.11,18.84,28.81,44,61.12,77,61.47h.6c28.68,0,37.2-18.78,76.67-19h.6c38.88,0,46.68,18.89,75.24,18.89h.6c33-.35,59.51-36.15,78.35-64.85,13.56-20.64,18.6-31,29-54.35-76.19-28.92-88.43-136.93-13.08-178.34-23-28.8-55.32-45.48-85.79-45.48Z"
          style={{ fill: "currentColor" }}
        />
        <path
          d="M340.25,32c-24,1.63-52,16.91-68.4,36.86-14.88,18.08-27.12,44.9-22.32,70.91h1.92c25.56,0,51.72-15.39,67-35.11C333.17,85.89,344.33,59.29,340.25,32Z"
          style={{ fill: "currentColor" }}
        />
      </symbol>
      <symbol id="cat-play" viewBox="0 0 512 512">
        <path
          d="M48,59.49v393a4.33,4.33,0,0,0,7.37,3.07L260,256,55.37,56.42A4.33,4.33,0,0,0,48,59.49Z"
          style={{ fill: "currentColor" }}
        />
        <path
          d="M345.8,174,89.22,32.64l-.16-.09c-4.42-2.4-8.62,3.58-5,7.06L285.19,231.93Z"
          style={{ fill: "currentColor" }}
        />
        <path
          d="M84.08,472.39c-3.64,3.48.56,9.46,5,7.06l.16-.09L345.8,338l-60.61-57.95Z"
          style={{ fill: "currentColor" }}
        />
        <path
          d="M449.38,231l-71.65-39.46L310.36,256l67.37,64.43L449.38,281C468.87,270.23,468.87,241.77,449.38,231Z"
          style={{ fill: "currentColor" }}
        />
      </symbol>
      <symbol id="cat-instagram" viewBox="0 0 512 512">
        <rect
          x="64"
          y="64"
          width="384"
          height="384"
          rx="104"
          ry="104"
          style={{ fill: "none", stroke: "currentColor", strokeWidth: "36px" }}
        />
        <circle
          cx="256"
          cy="256"
          r="84"
          style={{ fill: "none", stroke: "currentColor", strokeWidth: "36px" }}
        />
        <circle cx="362" cy="150" r="24" style={{ fill: "currentColor" }} />
      </symbol>
      <symbol id="cat-facebook" viewBox="0 0 512 512">
        <path
          d="M480,257.35c0-123.7-100.3-224-224-224s-224,100.3-224,224c0,111.8,81.9,204.47,189,221.29V322.12H164.11V257.35H221V208c0-56.13,33.45-87.16,84.61-87.16,24.51,0,50.15,4.38,50.15,4.38v55.13H327.5c-27.81,0-36.51,17.26-36.51,35v42h62.12l-9.92,64.77H291V478.66C398.1,461.85,480,369.18,480,257.35Z"
          style={{ fill: "currentColor", fillRule: "evenodd" }}
        />
      </symbol>
      <symbol id="cat-linkedin" viewBox="0 0 512 512">
        <path
          d="M444.17,32H70.28C49.85,32,32,46.7,32,66.89V441.61C32,461.91,49.85,480,70.28,480H444.06C464.6,480,480,461.79,480,441.61V66.89C480.12,46.7,464.6,32,444.17,32ZM170.87,405.43H106.69V205.88h64.18ZM141,175.54h-.46c-20.54,0-33.84-15.29-33.84-34.43,0-19.49,13.65-34.42,34.65-34.42s33.85,14.82,34.31,34.42C175.65,160.25,162.35,175.54,141,175.54ZM405.43,405.43H341.25V296.32c0-26.14-9.34-44-32.56-44-17.74,0-28.24,12-32.91,23.69-1.75,4.2-2.22,9.92-2.22,15.76V405.43H209.38V205.88h64.18v27.77c9.34-13.3,23.93-32.44,57.88-32.44,42.13,0,74,27.77,74,87.64Z"
          style={{ fill: "currentColor" }}
        />
      </symbol>
    </defs>
  </svg>
);

const Icon = ({ name, ...rest }) => (
  <svg viewBox="0 0 512 512" aria-hidden="true" {...rest}>
    <use href={`#cat-${name}`} />
  </svg>
);

class Catalogue extends React.Component {
  constructor(props) {
    super(props);
    this.state = { overKey: null, categoryKey: null };
  }

  get catalogue() {
    return buildCatalogue(this.props.products, localeKey());
  }

  /** Le premier rayon est ouvert par défaut, comme dans le design. */
  get activeOver() {
    const catalogue = this.catalogue;

    return (
      catalogue.find((over) => over.key === this.state.overKey) ||
      catalogue[0] ||
      null
    );
  }

  get activeCategory() {
    const over = this.activeOver;

    if (!over) {
      return null;
    }

    return (
      over.categories.find((c) => c.key === this.state.categoryKey) ||
      over.categories[0]
    );
  }

  /** Quantité déjà au panier, source de vérité pour les compteurs. */
  quantityOf(productId) {
    const line = this.props.cartItems?.find((item) => item?.id === productId);

    return line?.quantity || 0;
  }

  step(product, sign) {
    this.props.dispatch(cartApi(product.raw, sign));
  }

  switchLanguage(code) {
    cookies.set("i18next", code);
    window.location.reload();
  }

  renderRail(catalogue) {
    const active = this.activeOver;

    return (
      <aside className="wosh-cat__rail">
        <div className="wosh-cat__rail-inner" role="tablist">
          {catalogue.map((over) => {
            const on = over.key === active?.key;

            return (
              <button
                type="button"
                role="tab"
                aria-selected={on}
                key={over.key}
                className={`wosh-cat__over${on ? " wosh-cat__over--on" : ""}`}
                onClick={() =>
                  this.setState({ overKey: over.key, categoryKey: null })
                }
              >
                <span className="wosh-cat__over-badge">
                  {over.icon && <img src={over.icon} alt="" />}
                </span>
                <span className="wosh-cat__over-name">{over.name}</span>
              </button>
            );
          })}
        </div>
      </aside>
    );
  }

  /*
   * Le design masque la barre quand il n'y a qu'une catégorie. On l'affiche
   * quand même : c'est le seul endroit où l'icône de catégorie apparaît, et
   * la plupart des rayons n'en ont qu'une.
   */
  renderSubs(over) {
    if (!over.categories.length) {
      return null;
    }

    const active = this.activeCategory;

    return (
      <div className="wosh-cat__subs" role="tablist">
        {over.categories.map((category) => {
          const on = category.key === active?.key;
          /* Picto blanc sur l'onglet indigo actif, picto sombre au repos. */
          const icon = on ? category.icon : category.darkIcon || category.icon;

          return (
            <button
              type="button"
              role="tab"
              aria-selected={on}
              key={category.key}
              className={`wosh-cat__sub${on ? " wosh-cat__sub--on" : ""}`}
              onClick={(event) => {
                /* Barre plus large que la colonne : l'onglet choisi reste en vue. */
                event.currentTarget.scrollIntoView?.({ block: "nearest", inline: "nearest" });
                this.setState({ categoryKey: category.key });
              }}
            >
              {icon && <img src={icon} alt="" />}
              {category.name}
            </button>
          );
        })}
      </div>
    );
  }

  renderKiloCard() {
    const { t } = this.props;

    return (
      <div className="wosh-cat__kilo">
        <div className="wosh-cat__kilo-col">
          <div className="wosh-cat__kilo-title">
            {t("How to estimate the weight of your laundry")}
          </div>
          <div className="wosh-cat__kilo-pair">
            <div className="wosh-cat__kilo-tile">
              <span className="wosh-cat__kilo-badge">
                <Icon name="bag" />
              </span>
              <div>
                <div className="wosh-cat__kilo-strong">{t("Half a bag")}</div>
                <div className="wosh-cat__kilo-weak">≈ 5 kg</div>
              </div>
            </div>
            <div className="wosh-cat__kilo-tile wosh-cat__kilo-tile--full">
              <span className="wosh-cat__kilo-badge">
                <Icon name="bag" />
              </span>
              <div>
                <div className="wosh-cat__kilo-strong">{t("Full bag")}</div>
                <div className="wosh-cat__kilo-weak">≈ 10 kg</div>
              </div>
            </div>
          </div>
          <div className="wosh-cat__kilo-note">
            <strong>{t("Not sure?")}</strong>{" "}
            {t("Our experts weigh at pickup and adjust the price.")}
          </div>
        </div>

        <div className="wosh-cat__kilo-col wosh-cat__kilo-col--right">
          <div className="wosh-cat__eyebrow">{t("What is included")}</div>
          <div className="wosh-cat__kilo-line">
            <Icon name="check" />
            <span>{t("Everyday laundry (T-shirts, socks, underwear…)")}</span>
          </div>
          <div className="wosh-cat__kilo-line">
            <Icon name="check" />
            <span>{t("Household linen (towels, tea towels…)")}</span>
          </div>
          <div className="wosh-cat__kilo-small">
            {t(
              "If delicate or dry-clean-only items are found, we take care of them and bill them separately."
            )}
          </div>
        </div>
      </div>
    );
  }

  renderGrid(category) {
    const { t } = this.props;
    const products = category?.products || [];

    if (!products.length) {
      return <p className="wosh-cat__empty">{t("No products found")}</p>;
    }

    return (
      <div className="wosh-cat__grid">
        {products.map((product) => {
          const quantity = this.quantityOf(product.id);

          return (
            <div
              key={product.id}
              className={`wosh-cat__card${
                quantity > 0 ? " wosh-cat__card--on" : ""
              }`}
            >
              <div className="wosh-cat__card-art">
                <img src={product.icon} alt="" />
              </div>
              <div className="wosh-cat__card-name">{product.name}</div>
              <div className="wosh-cat__card-foot">
                <span className="wosh-cat__price">
                  {formatPrice(product.price)}
                </span>
                <div className="wosh-cat__stepper">
                  <button
                    type="button"
                    className="wosh-cat__step wosh-cat__step--minus"
                    aria-label={t("Remove")}
                    disabled={quantity === 0}
                    onClick={() => this.step(product, "minus")}
                  >
                    −
                  </button>
                  <span className="wosh-cat__qty">{quantity}</span>
                  <button
                    type="button"
                    className="wosh-cat__step"
                    aria-label={t("Add")}
                    onClick={() => this.step(product, "plus")}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderFooter() {
    const { t } = this.props;
    const current = cookies.get("i18next") || "en";

    return (
      <footer className="wosh-cat__footer">
        <div className="wosh-cat__footer-group">
          <span>© WOSH {new Date().getFullYear()}</span>
          <a
            href="https://www.wosh.be/legal/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            {t("Privacy Policy")}
          </a>
          <a
            href="https://www.wosh.be/legal/terms-conditions"
            target="_blank"
            rel="noreferrer"
          >
            {t("Terms & Conditions")}
          </a>
        </div>

        <div className="wosh-cat__footer-group" style={{ gap: 24 }}>
          <div className="wosh-cat__footer-group" style={{ gap: 16 }}>
            <a
              className="wosh-cat__store"
              href="https://apps.apple.com/be/app/wosh/id1612458076"
              target="_blank"
              rel="noreferrer"
            >
              <Icon name="apple" />
              App Store
            </a>
            <a
              className="wosh-cat__store"
              href="https://play.google.com/store/apps/details?id=com.woshuser"
              target="_blank"
              rel="noreferrer"
            >
              <Icon name="play" />
              Google Play
            </a>
          </div>

          <div className="wosh-cat__sep" />

          <div className="wosh-cat__footer-group" style={{ gap: 14 }}>
            <a
              className="wosh-cat__social"
              href="https://www.instagram.com/wosh.be/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <Icon name="instagram" />
            </a>
            <a
              className="wosh-cat__social"
              href="https://www.facebook.com/wosh.be"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <Icon name="facebook" />
            </a>
            <a
              className="wosh-cat__social"
              href="https://www.linkedin.com/company/wosh-be"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <Icon name="linkedin" />
            </a>
          </div>

          <div className="wosh-cat__sep" />

          <div className="wosh-cat__footer-group" style={{ gap: 12 }}>
            {LANGUAGES.map((language) => (
              <button
                type="button"
                key={language.code}
                className={`wosh-cat__lang${
                  current === language.code ? " wosh-cat__lang--on" : ""
                }`}
                onClick={() => this.switchLanguage(language.code)}
              >
                {language.label}
              </button>
            ))}
          </div>
        </div>
      </footer>
    );
  }

  renderCart() {
    const { t, cartItems, totalAmount, userName, history, editing } = this.props;
    const lines = cartItems || [];

    return (
      <aside className="wosh-cat__side">
        <div className="wosh-cat__side-inner">
        <div className="wosh-cat__hello">
          {t("Hello")} {userName?.user_name}
        </div>

        {/* Carte d'accueil de l'app mobile ; masquée pendant une modification de commande. */}
        {!editing && <HomeHero history={history} hasCart={lines.length > 0} />}

        <div className="wosh-cat__cart">
          <div className="wosh-cat__cart-head wosh-cat__eyebrow">
            {t("Your order")}
          </div>

          <div className="wosh-cat__cart-list">
            {lines.map((line) => (
              <div className="wosh-cat__line" key={line.id}>
                <div className="wosh-cat__line-body">
                  <div className="wosh-cat__line-name">
                    {productName(line, localeKey())}
                  </div>
                  <div className="wosh-cat__line-unit">
                    {formatPrice(line.price / (line.quantity || 1))} /{" "}
                    {t("piece")}
                  </div>
                </div>
                <div className="wosh-cat__stepper">
                  <button
                    type="button"
                    className="wosh-cat__step wosh-cat__step--minus"
                    aria-label={t("Remove")}
                    onClick={() => this.props.dispatch(cartApi(line, "minus"))}
                  >
                    −
                  </button>
                  <span className="wosh-cat__qty">{line.quantity}</span>
                  <button
                    type="button"
                    className="wosh-cat__step"
                    aria-label={t("Add")}
                    onClick={() => this.props.dispatch(cartApi(line, "plus"))}
                  >
                    +
                  </button>
                </div>
                <div className="wosh-cat__line-sum">
                  {formatPrice(line.price)}
                </div>
              </div>
            ))}

            {!lines.length && (
              <div className="wosh-cat__cart-empty">
                {t("Your cart is empty.")}
              </div>
            )}
          </div>

          <div className="wosh-cat__cart-foot">
            <div className="wosh-cat__cart-row">
              <span>{t("Pickup & delivery")}</span>
              <span className="wosh-cat__free">{t("Free")}</span>
            </div>
            <div className="wosh-cat__total">
              <span>{t("Total")}</span>
              <span>{formatPrice(totalAmount)}</span>
            </div>
            <button
              type="button"
              className="wosh-cat__cta"
              disabled={!lines.length}
              onClick={() => history.push(editing ? "/checkout" : "/checkout/pickup")}
            >
              {/* En modification de commande, le panier retourne au récapitulatif d'édition. */}
              {editing ? t("checkout.backToCheckout", { ns: "app" }) : t("Pick a slot")}
            </button>
          </div>
        </div>
        </div>
      </aside>
    );
  }

  render() {
    const { t, errorProducts } = this.props;
    const catalogue = this.catalogue;
    const over = this.activeOver;
    const category = this.activeCategory;

    if (errorProducts) {
      return (
        <div className="wosh-cat">
          <div className="wosh-cat__main">
            <p className="wosh-cat__empty">{t(errorProducts)}</p>
          </div>
        </div>
      );
    }

    return (
      <div className="wosh-cat">
        <Sprite />

        {this.renderRail(catalogue)}

        <main className="wosh-cat__main">
          {over && this.renderSubs(over)}

          <h1 className="wosh-cat__title">
            {category?.name || over?.name || ""}
          </h1>
          {category?.description && (
            <p className="wosh-cat__desc">{category.description}</p>
          )}

          {over && isKiloOverCategory(over) && this.renderKiloCard()}

          {this.renderGrid(category)}

          <div className="wosh-cat__spacer" />
          {this.renderFooter()}
        </main>

        {this.renderCart()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  products: state?.cart?.mockItems,
  cartItems: state?.cart?.cartItems,
  totalAmount: state?.cart?.totalAmount,
  userName: state?.auth?.user,
  errorProducts: state?.cart?.error,
  editing: Boolean(state?.auth?.editContext),
});

export default compose(
  withTranslation(),
  connect(mapStateToProps)
)(Catalogue);
